package com.vizio.redwolf.pay.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class Card(
    @SerialName("cardToken") val cardToken: String,
    @SerialName("cardType") val cardType: String,
    @SerialName("cardholderName") val cardholderName: String? = null,
    @SerialName("lastFour") val lastFour: String,
    @SerialName("expirationDate") val expirationDate: String,
    @SerialName("expirationMessage") val expirationMessage: String? = null,
    @SerialName("isExpired") val isExpired: Boolean,
    @SerialName("isDefault") val isDefault: Boolean,
    @SerialName("imageUrl") val imageUrl: String,
    @SerialName("billingAddress") val billingAddress: BillingAddress
)
